import customAxios from './axiosConfig'

const CommunicationService = {
  list: function(filters) {
    const api_url = window.Urls['accountant_communication_list']()
    return customAxios.get(api_url, { params: filters })
  },
  update: function(id, data) {
    const api_url = window.Urls['accountant_communication_detail'](id)
    return customAxios.put(api_url, data)
  },
  byId: function(id) {
    const api_url = window.Urls['accountant_communication_detail'](id)
    return customAxios.get(api_url)
  },
  createCommunication: function(data) {
    const api_url = window.Urls['accountant_communication_list']()
    return customAxios.post(api_url, data)
  },
}

export default CommunicationService
